<template>
  <svg
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 21 20"
    fill="none"
    class="icon-restart"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.2498 0.999592C7.15978 0.859592 2.98978 4.93959 2.98978 9.99959H1.19978C0.749777 9.99959 0.529777 10.5396 0.849777 10.8496L3.63978 13.6496C3.83978 13.8496 4.14978 13.8496 4.34978 13.6496L7.13978 10.8496C7.45978 10.5396 7.22978 9.99959 6.78978 9.99959H4.98978C4.98978 6.09959 8.16978 2.94959 12.0898 2.99959C15.8098 3.04959 18.9398 6.17959 18.9898 9.89959C19.0398 13.8096 15.8898 16.9996 11.9898 16.9996C10.3798 16.9996 8.88978 16.4496 7.70978 15.5196C7.30978 15.2096 6.74978 15.2396 6.38978 15.5996C5.96978 16.0296 5.99978 16.7296 6.46978 17.0996C7.98978 18.2896 9.90978 18.9996 11.9898 18.9996C17.0398 18.9996 21.1298 14.8296 20.9898 9.73959C20.8598 5.04959 16.9398 1.12959 12.2498 0.999592Z"
      fill="currentColor"
    />
  </svg>
</template>
